'use client';

import { Button, ButtonType, ButtonVariant, FlexBox, IconName, Justify } from '@bytel/trilogy-react';

type NavButtonsProps = {
    isNextDisabled?: boolean;
    nextLabel?: string;
    nextUrl?: string;
    onNext?: () => void;
    backLabel?: string;
    backUrl?: string;
    onBack?: () => void;
    type?: ButtonType;
    isLoading?: boolean;
};

export function NavButtons({
    isNextDisabled = false,
    nextLabel = 'Étape suivante',
    nextUrl,
    onNext: _onNext,
    backLabel = 'Retour',
    backUrl,
    onBack,
    type,
    isLoading,
}: Readonly<NavButtonsProps>) {
    const handleNextClick = () => {
        if (!isNextDisabled) {
            _onNext?.();
        }
    };

    return (
        <FlexBox
            justify={Justify.SPACE_BETWEEN}
            className='is-bordered-top is-sticky-bottom has-background-white p-small '
        >
            <Button
                id='backActionBtn'
                href={backUrl}
                variant={ButtonVariant.GHOST}
                onClick={onBack}
                iconName={IconName.ARROW_LEFT}
                aria-label='Retour à la page précédente'
                className='is-marginless'
            >
                {backLabel}
            </Button>
            <Button
                data-testid={`btn_${nextLabel}`}
                id='primaryActionBtn'
                disabled={isNextDisabled}
                href={nextUrl}
                variant={ButtonVariant.CONVERSION}
                loading={isLoading}
                onClick={handleNextClick}
                type={type}
                className='is-marginless'
            >
                {nextLabel}
            </Button>
        </FlexBox>
    );
}
